module.exports = __webpack_public_path__ + "10d2fbfd97ff881fca079075d4d3c203.svg";